import { render } from "./tpl_join_group.vue?vue&type=template&id=4beee68a&scoped=true"
import script from "./tpl_join_group.vue?vue&type=script&lang=js"
export * from "./tpl_join_group.vue?vue&type=script&lang=js"

import "./tpl_join_group.vue?vue&type=style&index=0&id=4beee68a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4beee68a"],['__file',"src/views/wap/template/tpl_join_group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4beee68a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4beee68a', __exports__)) {
    console.log('reload')
    api.reload('4beee68a', __exports__)
  }
  
  module.hot.accept("./tpl_join_group.vue?vue&type=template&id=4beee68a&scoped=true", () => {
    console.log('re-render')
    api.rerender('4beee68a', render)
  })

}


export default __exports__